import { createStore } from 'satcheljs';
export default createStore('dateHeadersOption', {
    isEnabled: null,
})();
//# sourceMappingURL=store.js.map